import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import '@progress/kendo-theme-material/dist/all.css';
import './App.scss';
import {createBrowserHistory} from 'history';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));// Containers
/* ******************pages********************** */
const Accueil = React.lazy(() => import('./views/Pages/Accueil'));
const Login = React.lazy(() => import('./views/Pages/Login/login'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));

const history = createBrowserHistory();
const locat = history.location;
let authInfos = JSON.parse(localStorage.getItem("authInfos"));
if (authInfos === null && locat.pathname === "/") {
  //history.replace("/");//Use push, replace, and go to navigate around.
}
class App extends Component {

  render() {
    return (
      <HashRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route exact path="/" name="Accueil" render={props => <Accueil {...props}/>} />
              <Route exact path="/login" name="Login" render={props => <Login {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route name="Home" render={props => <DefaultLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
